import React from "react";
import "./References.scss";
import { Button, Grid } from "@material-ui/core";
// import OpenInNewIcon from "@material-ui/icons/OpenInNew";

function References(props) {
  const { refs } = props;

  const handleClick = (url) => {
    window.open(url);
  };
  return (
    <Grid container className="references" spacing={2}>
      {refs.map((ref) => (
        <Grid key={ref.label} item xs={6}>
          <Button
            className="link-button"
            variant="contained"
            color="primary"
            // endIcon={<OpenInNewIcon />}
            onClick={() => handleClick(ref.url)}
          >
            {ref.label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
}

export default References;
